/* eslint-disable no-undef */
import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { jwtDecode } from "jwt-decode";
import toast from "react-hot-toast";
export let CartContext = createContext();
let headers = { token: localStorage.getItem("userToken") };
export function CartContextProvider(props) {
	const [cartId, setCartId] = useState(null);
	const [numOfCarts, setNumOfCarts] = useState(0);
	const [userData, setUserData] = useState(null);
	const [cartDetails, setCartDetails] = useState(null);
	async function commitGettingCart() {
		let response = await getLoggedUserCart();
		if (response?.data?.status === "success") {
			setNumOfCarts(response.data.numOfCartItems);
			setCartId(response.data.data._id);
		}
	}
	function saveUserData() {
		let encodedToken = localStorage.getItem("userToken");
		if (encodedToken) {
			let decodedToken = jwtDecode(encodedToken);
			setUserData(decodedToken);
		} else {
			setUserData(null);
		}
	}
	useEffect(() => {
		commitGettingCart();
		saveUserData();
	}, []);
	function addToCart(productId) {
		return axios
			.post(
				`https://ecommerce.routemisr.com/api/v1/cart`,
				{
					productId: productId,
				},
				{
					headers: headers,
				}
			)
			.then(response => response)
			.catch(error => error);
	}
	function getLoggedUserCart() {
		return axios
			.get(`https://ecommerce.routemisr.com/api/v1/cart`, {
				headers: headers,
			})
			.then(response => response)
			.catch(error => error);
	}
	function removeItem(productId) {
		return axios
			.delete(`https://ecommerce.routemisr.com/api/v1/cart/${productId}`, {
				headers: headers,
			})
			.then(response => response)
			.catch(error => error);
	}
	function updateProductCount(productId, count) {
		return axios
			.put(
				`https://ecommerce.routemisr.com/api/v1/cart/${productId}`,
				{
					count: count,
				},
				{
					headers: headers,
				}
			)
			.then(response => response)
			.catch(error => error);
	}
	function clearCart() {
		return axios
			.delete(`https://ecommerce.routemisr.com/api/v1/cart`, {
				headers: headers,
			})
			.then(response => response)
			.catch(error => error);
	}
	function onlinePayment(cartId, shippingAddress) {
		return axios
			.post(
				`https://ecommerce.routemisr.com/api/v1/orders/checkout-session/${cartId}?url=${window.location.origin}`,
				{
					shippingAddress: shippingAddress,
				},
				{
					headers: headers,
				}
			)
			.then(response => response)
			.catch(error => error);
	}
	// add product
	async function addProduct(productId) {
		if (!productId) {
			toast.error("Product ID not found!", { duration: 2000 });
			return;
		}

		let response = await addToCart(productId);

		if (response?.data?.status === "success") {
			setNumOfCarts(response.data.numOfCartItems);
			toast.success(response.data.message, { duration: 2000 });
		} else {
			toast.error("Failed to add product to cart!", { duration: 2000 });
		}

		console.log(response);
	}
	// delete item
	async function deleteItem(productId) {
		let response = await removeItem(productId);
		setCartDetails(response.data.data);
		setNumOfCarts(response.data.numOfCartItems);
		toast("product removed successfully");
	}
	return (
		<CartContext.Provider
			value={{
				userData,
				setUserData,
				saveUserData,
				setNumOfCarts,
				numOfCarts,
				cartId,
				onlinePayment,
				addToCart,
				getLoggedUserCart,
				removeItem,
				updateProductCount,
				addProduct,
				clearCart,
				deleteItem,
				cartDetails,
				setCartDetails,
			}}>
			{props.children}
		</CartContext.Provider>
	);
}
